import styles from './main.module.css';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextEditor } from '../shared/text-editor';
import * as FileService from 'services/file';
import { useContactFieldService } from 'hooks/users/contact_field';
import { SimpleInput } from 'app/shared/input';
import { processCustomAttribute } from 'app/shared/utils/text';
import Spinner from 'app/shared/spinners/spinner-50/spinner-50';

const DEFAULT_OPTIONS = [
  { value: '@email', text: 'Email Address', type: 'default' },
  { value: '@firstname', text: 'First name', type: 'default' },
  { value: '@gender', text: 'Gender', type: 'default' },
  { value: '@lastname', text: 'Last name', type: 'default' },
  { value: '@phone_number', text: 'Phone Number', type: 'default' }
];

const DEFAULT_KEYS = ['firstname', 'lastname', 'email', 'phone_number', 'gender'];

export const MainForm = ({
  titleValue,
  value,
  onEditorChange,
  onContinue = () => {},
  onTitleChange = () => {},
  draft_status = '',
  is_continue_disabled = false
}) => {
  const { token } = useSelector((state) => state.user_data);
  const { fetchContactFields } = useContactFieldService();

  const [auto_complete_options, setAutoCompleteOptions] = useState(DEFAULT_OPTIONS);
  const [is_loading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchContactFields()
      .then(({ fields: [record] }) => {
        if (!record) return;
        const { custom_fields } = record;
        if (!custom_fields.length) return;
        const custom = custom_fields
          .filter((f) => !DEFAULT_KEYS.includes(f))
          .map((f) => ({
            value: `@${f}`,
            text: processCustomAttribute(f),
            type: 'custom'
          }));
        setAutoCompleteOptions(() => [...DEFAULT_OPTIONS, ...custom]);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const uploadImage = (blobInfo, success, failure, progress) => {
    const data = new FormData();
    data.append('image', blobInfo.blob());
    FileService.uploadTinyMCEImage(success, failure, progress, { data, token });
  };

  return is_loading ? (
    <div className={styles.spinnerWrapper}>
      <Spinner />
    </div>
  ) : (
    <TextEditor
      default_value={value}
      onContinue={onContinue}
      onTextChange={(text) => onEditorChange('body', text)}
      onImageUpload={uploadImage}
      auto_complete_options={auto_complete_options}
      placeholder="Start creating..."
      isContinueDisabled={is_continue_disabled}
      statusSlot={
        draft_status ? (
          <>
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'var(--warning, #f5a623)',
                display: 'inline-block',
                flexShrink: 0
              }}
            />
            {draft_status}
          </>
        ) : null
      }
      titleSlot={
        <SimpleInput
          className={styles.titleInput}
          onInput={onTitleChange}
          value={titleValue}
          placeholder="Type your subject here..."
        />
      }
    />
  );
};
